var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BankTabber"},[_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"tab-header font-size-middle",class:{
            active: index == _vm.activeTab
        },on:{"click":function($event){return _vm.tabClicked(index)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),_c('div',{staticClass:"selection-box",style:(( _obj = {}, _obj['--tab-length'] = ((100/_vm.tabs.length) + "%"), _obj['--tab-offset'] = ((100/_vm.tabs.length * _vm.activeTab) + "%"), _obj ))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }